import { render, staticRenderFns } from "./task-center.vue?vue&type=template&id=29c3dcc9&scoped=true"
import script from "./task-center.vue?vue&type=script&lang=js"
export * from "./task-center.vue?vue&type=script&lang=js"
import style0 from "./task-center.vue?vue&type=style&index=0&id=29c3dcc9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29c3dcc9",
  null
  
)

export default component.exports